import styled from 'styled-components';

import { Box } from '../../../components/Box';

export const StyledBottomSection = styled(Box)`
  border-top: ${({ theme }) => theme.border('lightGrey', 1)};
`;
